var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0.999878H5.5C4.0418 1.00147 2.64377 1.58144 1.61267 2.61254C0.581561 3.64365 0.00158817 5.04167 0 6.49988L0 17.4999C0.00158817 18.9581 0.581561 20.3561 1.61267 21.3872C2.64377 22.4183 4.0418 22.9983 5.5 22.9999H18.5C19.9582 22.9983 21.3562 22.4183 22.3873 21.3872C23.4184 20.3561 23.9984 18.9581 24 17.4999V6.49988C23.9984 5.04167 23.4184 3.64365 22.3873 2.61254C21.3562 1.58144 19.9582 1.00147 18.5 0.999878ZM18.5 3.99988C19.1065 4.0019 19.6911 4.22643 20.143 4.63088L13.643 11.1309C13.2015 11.5525 12.6145 11.7878 12.004 11.7878C11.3935 11.7878 10.8065 11.5525 10.365 11.1309L3.865 4.63088C4.31485 4.22825 4.8963 4.00385 5.5 3.99988H18.5ZM18.5 19.9999H5.5C4.83696 19.9999 4.20107 19.7365 3.73223 19.2676C3.26339 18.7988 3 18.1629 3 17.4999V8.01688L8.239 13.2559C8.73276 13.7499 9.319 14.1417 9.96424 14.4091C10.6095 14.6764 11.3011 14.814 11.9995 14.814C12.6979 14.814 13.3895 14.6764 14.0348 14.4091C14.68 14.1417 15.2662 13.7499 15.76 13.2559L21 8.01688V17.4999C21 18.1629 20.7366 18.7988 20.2678 19.2676C19.7989 19.7365 19.163 19.9999 18.5 19.9999Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.47459143bb1ed0140c898fac72cda691.svg";
export { ForwardRef as ReactComponent };